/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'sag-ui-range-multi',
  template: `<div
    sag-ui-range-base-multi
    [track]="track"
    [thumbs]="[thumb1, thumb2]"
    [inputs]="[input1, input2]"
    (click)="click.emit($event)"
    (focus)="focus.emit($event)"
    (blur)="onTouched(); blur.emit($event)"
  >
    <div sag-ui-range-track #track>
      <span
        sag-ui-range-thumb
        sag-ui-tooltip
        [disabled]="disabled"
        #thumb1
      ></span>
      <span
        sag-ui-range-thumb
        sag-ui-tooltip
        [disabled]="disabled"
        #thumb2
      ></span>
    </div>
    <input
      sag-ui-range
      type="range"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      [value]="value[0]"
      (change)="onChange($event, 0)"
      #input1
    />
    <input
      sag-ui-range
      type="range"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      [value]="value[1]"
      (change)="onChange($event, 1)"
      #input2
    />
  </div>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeMultiComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RangeMultiComponent),
      multi: true,
    },
  ],
})
export class RangeMultiComponent implements ControlValueAccessor, Validator {
  @Input() disabled = false;
  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() value = [this.min, this.min];

  
  @Output() change = new EventEmitter<Event>();
  @Output() click = new EventEmitter<Event>();
  @Output() focus = new EventEmitter<Event>();
  @Output() blur = new EventEmitter<Event>();

  onChangeEvent = (_: any) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeEvent = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    this.value[index] = parseFloat(input.value);
    this.onChangeEvent(this.value);
    this.change.emit(event);
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return null;
  }
}
